import {CodeSpecNum, DrawerType} from "../../constant/CodeSpecNum";

export const adminAuth = [
    {id: "1", name: "유지보수업체"},
    {id: "2", name: "협업사용부서"},
    {id: "100", name: "통합관리업체"},
    {id: "200", name: "자산운영담당자"},
    {id: "1000", name: "슈퍼관리자"}
]

export const adminSetting = [
    {id: "Y", name: "설정"},
    {id: "N", name: "미설정"}
]

export const TureFalseSetting = [
    {id: "true", name: "설정"},
    {id: "false", name: "미설정"}
]

export const fileSetting = [
    {id: "Y", name: "설정"},
    {id: "*", name: "미설정"}
]


export const dateSearch = [
    {id: "Y", name: "매년 1월 1일"},
    {id: "M", name: "매달 1일"},
    {id: "D", name: "직접 입력"}
]

export const qrUse = [
    {id: "LOGIN", name: "자동 로그인 용도"},
    {id: "QUICKVIEW", name: "간편 자산보기 용도"}
]

export const qrPrint = [
    {id: "A4", name: "A4 용지 타입"},
    {id: "ROLL", name: "ROLL 기반 타입"}
]

export const initialPageable = {
    sort: "createdAt",
    desc: true,
    size: 10,
    totalElements: 0,
    totalPages: 0,
    page: 0,
}

export const initialSearchText = {
    searchTxt: ""
}

export const userDrawers = [
    DrawerType.USER, DrawerType.USER_LIST, DrawerType.HANDLER, DrawerType.REQUESTER, DrawerType.APPLIER
]

export const AssetCodeTypes = Object.freeze({
    ASSET_CODE_GROUP: {
        value: "ASSET_CODE_GROUP", tabs: [{clicked: true, name: "코드관리"},], header : "자산그룹",
        CodeSpecNum: CodeSpecNum.AssetGroupCode, title: "자산그룹명", indicator: "환경설정 > 코드관리 > 그룹코드 > 자산그룹"
    },
    ASSET_CODE_TASK: {
        value: "ASSET_CODE_TASK", tabs: [{clicked: true, name: "코드관리"},], header : "업무그룹",
        CodeSpecNum: CodeSpecNum.TaskGroupCode, title: "업무그룹명", indicator: "환경설정 > 코드관리 > 그룹코드 > 업무그룹"
    },
    ASSET_LOCATION_CODE: {
        value: "ASSET_LOCATION_CODE", tabs: [{clicked: true, name: "코드관리"},], header : "위치관리",
        CodeSpecNum: CodeSpecNum.AssetLocation, title: "위치명", indicator: "환경설정 > 코드관리 > 그룹코드 > 위치관리"
    },
    ASSET_MEMO_CODE: {
        value: "ASSET_MEMO_CODE", tabs: [{clicked: true, name: "코드관리"},], header : "자산기록 관리",
        CodeSpecNum: CodeSpecNum.AssetMemo, title: "자산기록 코드명", indicator: "환경설정 > 코드관리 > 그룹코드 > 자산기록 관리"
    },
    DILIGENCE_CODE: {
        value: "DILIGENCE_CODE", tabs: [{clicked: true, name: "코드관리"},], header : "실사관리",
        CodeSpecNum: CodeSpecNum.DiligenceCode, title: "실사코드명", indicator: "환경설정 > 코드관리 > 자산코드 > 실사관리"
    },
    PURCHASE_CODE_GROUP: {
        valueL: "PURCHASE_CODE_GROUP", tabs: [{clicked: true, name: "코드관리"},], header : "구매관리(방법)",
        CodeSpecNum: CodeSpecNum.PurchaseSupplyMethodCode, title: "구매관리(방법)명", indicator: "환경설정 > 코드관리 > 그룹코드 > 구매관리(방법)"
    },
    PURCHASE_CODE_GROUP_CATEGORY: {
        value: "PURCHASE_CODE_GROUP_CATEGORY", tabs: [{clicked: true, name: "코드관리"},], header : "구매관리(구분)",
        CodeSpecNum: CodeSpecNum.PurchaseSupplyCategoryCode, title: "구매관리(구분)명", indicator: "환경설정 > 코드관리 > 그룹코드 > 구매관리(구분)"
    },
    RENTAL_ASSET_CODE: {
        value: "RENTAL_ASSET_CODE", tabs: [{clicked: true, name: "코드관리"},], header : "대여그룹관리",
        CodeSpecNum: CodeSpecNum.RentalAssetCode, title: "대여그룹 코드명", indicator: "환경설정 > 코드관리> 라이프사이클 > 대여그룹관리"
    },
    INSPECTION_CODE: {
        value: "INSPECTION_CODE", tabs: [{clicked: true, name: "코드관리"},], header : "점검관리",
        CodeSpecNum: CodeSpecNum.InspectionRequestCode, title: "점검코드명", indicator: "환경설정 > 코드관리 > 유지관리 > 점검관리"
    },
    INCIDENT_CODE: {
        value: "INCIDENT_CODE", tabs: [{clicked: true, name: "코드관리"},], header : "장애관리",
        CodeSpecNum: CodeSpecNum.IncidentRequestCode, title: "장애코드명", indicator: "환경설정 > 코드관리 > 유지관리 > 장애관리"
    },
    WORK_CODE: {
        value: "WORK_CODE", tabs: [{clicked: true, name: "코드관리"},], header : "작업관리",
        CodeSpecNum: CodeSpecNum.WorkRequestCode, title: "작업코드명", indicator: "환경설정 > 코드관리 > 유지관리 > 작업관리"
    },
    INTRODUCTION_CODE: {
        value: "INTRODUCTION_CODE", tabs: [{clicked: true, name: "코드관리"},], header : "자산도입코드",
        CodeSpecNum: CodeSpecNum.IntroductionRequestCode, title: "도입코드명", indicator: "환경설정 > 코드관리 > 라이프사이클 > 자산도입코드"
    },
    DISPOSE_CODE: {
        value: "DISPOSE_CODE", tabs: [{clicked: true, name: "코드관리"},], header : "자산폐기코드",
        CodeSpecNum: CodeSpecNum.DisposeRequestCode, title: "폐기코드명", indicator: "환경설정 > 코드관리 > 라이프사이클 > 자산폐기코드"
    },
    ASSET_SLA_GROUP_CODE: {
        value: "ASSET_SLA_GROUP_CODE", tabs: [{clicked: true, name: "코드관리"},], header : "SLA 그룹관리",
        CodeSpecNum: CodeSpecNum.SlaGroupCode, title: "SLA 그룹명", indicator: "환경설정 > 코드관리 > 자산코드 > SLA 그룹"
    },
});